import { Theme } from '@mui/material';

/**
 * Shared constants for objective components
 */

export const DEFAULT_VALUES = {
  PROFITABLE_DAYS: 0,
  INACTIVE_DAYS: 0,
  CONSISTENCY_TARGET: 0,
  CURRENCY_VALUE: 0,
  OBJECTIVE_ICON_SIZE: 24,
} as const;

export const OBJECTIVE_STYLES = {
  MIDNIGHT_CONTAINER: {
    mt: 3,
    backgroundColor: (theme: Theme) => theme.palette.background.contrast,
    padding: (theme: Theme) => `${theme.spacing(1)} ${theme.spacing(2)}`,
    borderRadius: (theme: Theme) => theme.spacing(10),
    border: (theme: Theme) => `1px solid ${theme.palette.text.fifth}`,
    whiteSpace: 'nowrap',
    width: 'fit-content',
  },
  INACTIVE_DAYS_CONTAINER: {
    mt: 3,
    backgroundColor: (theme: Theme) => theme.palette.background.contrast,
    padding: (theme: Theme) => `${theme.spacing(1)} ${theme.spacing(2)}`,
    borderRadius: (theme: Theme) => theme.spacing(10),
    border: (theme: Theme) => `1px solid ${theme.palette.text.fifth}`,
    whiteSpace: 'nowrap',
    width: 'fit-content',
  },
  BOLD_TEXT: {
    fontWeight: 'bold',
  },
} as const;

export const OBJECTIVE_ICONS = {
  WARNING_CIRCLE: 'WarningCircle',
  CALENDAR: 'ICalendarBlank',
  SPEEDOMETER: 'Speedometer',
  INFO: 'Info',
  MIDNIGHT: 'Midnight',
} as const;

export const DAILY_LIMIT_CONSTANTS = {
  TOOLTIP_MIN_WIDTH: 500,
  MIDNIGHT_ICON_SIZE: 22,
  INFO_ICON_SIZE: 25,
  CURRENCY_FONT_SIZE: 20,
  MIDNIGHT_ICON_STYLES: {
    cursor: 'pointer',
    borderRadius: '50%',
    padding: 1,
  },
} as const;

export const PROFITABLE_DAYS_CONSTANTS = {
  TOOLTIP_MAX_WIDTH: 280,
  INFO_ICON_SIZE: 16,
} as const;

export const MOBILE_FONT_SIZES = {
  LABEL: 12, // Mobile/Body2/Regular
  PRIMARY_VALUE: 19, // Mobile/H6/Regular
  SUBTITLE_SEMIBOLD: 18, // Subtitle 2/Semibold
} as const;
